export const TEST_SERVER_FILE_NOTE =
  'As this is a test server, files are automatically deleted after every new deployment to the server due to storage restrictions, please move to live server for permanent storage.';
